import { Grid, Table, TableCell, Typography } from "@mui/material";
import { styled, lighten, darken } from "@mui/material/styles";

export const Container = styled(Grid)(({ theme }) => ({
  // display: "flex",
  // flexDirection:"column",
  // alignItems:"flex-start",
  // width:"60%",
  ".MuiButton-root": {
    transition: "all .3s ease",
    opacity: 0.3,
    height: "10px",
    "& svg": {
      fontSize: `${theme.typography.body2.fontSize}px`,
    },
  },

  "&:hover .MuiButton-root": {
    opacity: 1,
  },
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  borderCollapse: "separate",
  borderSpacing: "0px 8px",
  "& .MuiTableRow-root": {
    "&:first-of-type": {
      "& .MuiTableCell-root": {
        "&:nth-of-type(1), &:nth-of-type(2)": {
          borderBottom: "none",
        },
      },
    },
    "& .MuiTableCell-root": {
      padding: "10px",
      "&:first-of-type": {
        fontSize: `${theme.typography.body2.fontSize}px`,
      },
    },
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: `${theme.typography.body2.fontSize}px`,
  borderRadius: "5px",
  border: `1px solid ${darken(theme.palette.background.paper, 0.05)}`,
  position: "relative",
  overflow: "visible",
  "& .MuiButtonBase-root": {
    padding: "0 !important",
  },
}));

export const Label = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: "-7px",
  left: "10px",
  color: lighten(theme.palette.text.secondary, 0.5),
  backgroundColor: theme.palette.background.default,
}));
